import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function Playlists() {
    // full-bleed iframe with its own background - suppress the global grain
    // wallpaper so it can't bleed behind it (same as the home page)
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / Playlists</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <iframe
                title="ojee.net playlists"
                src="/redesign-demos/playlists/index.html?v=2"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#06060a', zIndex: 1 }}
            />
        </>
    );
}

export default Playlists;
